import { Tabs } from '@ark-ui/react';
import { css } from '@styled-system/css';
import type { FC } from 'react';

import { SELL_HISTORY_TABS, type SellHistoryTabValue } from '../types';

interface SellHistoryTabsProps {
  activeTab: SellHistoryTabValue;
  onTabChange: (tab: SellHistoryTabValue) => void;
}

export const SellHistoryTabs: FC<SellHistoryTabsProps> = ({ activeTab, onTabChange }) => {
  const tabsRootStyles = css({
    display: 'flex',
    alignItems: 'stretch',
    bg: 'transparent',
    gap: '2rem',
    mt: '-1.5rem',
  });

  const tabTriggerStyles = css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '0.0625rem',
    px: 0,
    py: '0.75rem',
    fontSize: 'sm',
    fontWeight: 500,
    fontFamily: 'Manrope, sans-serif',
    color: 'font.muted',
    bg: 'transparent',
    border: 'none',
    cursor: 'pointer',

    // Prendre l'espace de la ligne de soulignement
    // Pour éviter l'effet de "saut" lors du changement de tab
    '&::after': {
      content: '""',
      w: '100%',
      h: '1px',
      bg: 'transparent', // Ligne transparente par défaut
      display: 'block',
    },

    // État actif
    _selected: {
      color: 'font.primary', // font-primary du design (état actif)
      transformOrigin: 'left bottom',
      transform: 'scale(1.05)', // Légère mise en avant

      // Ligne de soulignement pour l'état actif
      '&::after': {
        content: '""',
        w: '100%',
        h: '1px',
        bg: 'font.primary', // Ligne blanche comme dans le design
        borderRadius: '99px',
        display: 'block',
      },
    },

    // État hover
    _hover: {
      color: 'font.muted', // Couleur intermédiaire au hover
    },

    // Focus states
    _focus: {
      outline: 'none',
    },
  });

  return (
    <Tabs.Root value={activeTab} onValueChange={(details) => onTabChange(details.value as SellHistoryTabValue)}>
      <Tabs.List className={tabsRootStyles}>
        {SELL_HISTORY_TABS.map((tab) => (
          <Tabs.Trigger key={tab.value} value={tab.value} className={tabTriggerStyles}>
            {tab.label}
          </Tabs.Trigger>
        ))}
      </Tabs.List>
    </Tabs.Root>
  );
};
